
<div class="row">
    <div class="col-12">

        <!-- title -->
        <div class="title">
            <h5> Вы действительно хотите удалить выбранную группу атрибутов? </h5>
        </div>

        <!-- content -->
        <div class="content">

            <!-- info -->
            <div class="info">
                <ul *ngFor="let info of attributeInfo">
                    <li *ngIf="info.count != 0"> В группе <b>{{ info.name }}</b> используется {{ info.count }} атрибута(ов) </li>
                </ul>
            </div>

        </div>

        <!-- buttons -->
        <div class="buttons">

            <!-- delete -->
            <button type="button" class="btn btn-primary delete" (click)="delete()" [disabled]="attrCount != 0">
                Удалить
            </button>

            <!-- close -->
            <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
                Закрыть
            </button>

        </div>

    </div>
</div>
